<template>
  <div>
    <header class="bar bar-nav">
      <h1 class="title">选择支付配送方式</h1>
      <router-link :to="{name : 'orderContent'}" class="button button-link button-nav pull-left">
        <span class="icon icon-left" style="font-size: 18px">返回</span>
      </router-link>
    </header>
    <div class="content">
      <div class="checkout-title">
        <span>结算方式</span>
      </div>
      <div class="list-block media-list" style="margin-top: 1px;margin-bottom:2px;">

        <ul>
          <li>
            <div class="item-inner" style="left: 10px;">
              <div class="row">
                <div class="item-title button col-50" data-payType = '1'>预支付</div>
                <div class="item-title-after button col-50" data-payType = '2'>后支付</div>
              </div>
              <div class="row">
                <div class="item-title button col-50" data-payType = '3'>先货后款</div>
                <div class="item-title-after button col-50" data-payType = '4'>在线支付</div>
              </div>
              <!--<div class="item-subtitle">纸质发票</div>-->
              <!--<div class="item-text">此处是文本内容...</div>-->
            </div>
          </li>
        </ul>
      </div>
      <div class="checkout-title">
        <span>配送方式</span>
      </div>
      <div class="list-block media-list" style="margin-top: 2px;margin-bottom:2px;">
        <ul>
          <li>
            <!--<div class="item-media"><i class="icon icon-form-name"></i></div>-->
            <div class="item-inner"  style="left: 10px;">
              <div class="row">
                <div class="item-title button col-50">顺丰快递</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// PayDetail.vue?f9e91afc